import { AxiosResponse } from "axios";
import api, { apiService } from "./api";

/**
 * 从 Content-Disposition 中解析文件名
 */
function getFilenameFromDisposition(disposition?: string) {
  if (!disposition) return;

  // RFC 5987 (filename*=UTF-8'')
  const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''(.+)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1]);
  }

  // 普通 filename=""
  const asciiMatch = disposition.match(/filename\s*=\s*"?([^"]+)"?/i);
  if (asciiMatch) {
    return asciiMatch[1];
  }

  return;
}

/**
 * 批量下载知识库文件
 */
export const knowledgeBatchDownload = async (
  ids: number[],
  fallbackFilename = "download.zip"
) => {
  const response: AxiosResponse<Blob> = await apiService.requestRaw<Blob>({
    url: '/knowledge/batch_download',
    method: 'POST',
    data: {
      knowledge_folder_item_id: ids,
    },
    responseType: 'blob',
    timeout: 1000 * 60 * 5, // 5分钟超时
  });

  // 从响应头解析文件名
  const disposition = (response).headers["content-disposition"];
  const filename = getFilenameFromDisposition(disposition) || fallbackFilename;

  const blob = new Blob([response.data], {
    type: response.headers["content-type"] || "application/octet-stream",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  // 兼容 Firefox
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};
